export const BONUS_TAB = {
  OPEN: 'open',
  COMPLETED: 'completed',
  EXPIRED: 'expired',
  FAILED: 'failed',
} as const;

export type BonusTab = (typeof BONUS_TAB)[keyof typeof BONUS_TAB];
export type BonusTabStatus = BonusTab;

export enum CampaignProduct {
  SPORTSBOOK = 'SPORTSBOOK',
  CASINO = 'CASINO',
  ALL = 'ALL',
}

export enum BonusStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  FORFEITED = 'FORFEITED',
}

export enum BonusProgramType {
  FIRST_TIME_DEPOSIT = 'FIRST_TIME_DEPOSIT',
  WELCOME_BONUS = 'WELCOME_BONUS',
}

export enum WelcomeBonusOption {
  SPORTSBOOK = 'SPORTSBOOK',
  CASINO = 'CASINO',
  NO_BONUS = 'NO_BONUS',
}

export type WelcomeBonusSelectionData = {
  option: WelcomeBonusOption;
  selectedAt: string;
  campaignId?: string | null;
  activatedAt?: string | null;
  activatedCampaignId?: string | null;
};

export type WelcomeBonusOptionData = {
  product: Exclude<WelcomeBonusOption, WelcomeBonusOption.NO_BONUS>;
  campaignId: string;
  name: string;
  description: string | null;
  rewardType: string | null;
  bonusPercentage: number | null;
  fixedAmount: number | null;
  capLimit: number;
  minDepositAmount: number;
  timeframe: number | null;
  wageringRequirement: number | null;
  multiplier: number | null;
};

export type WelcomeBonusAvailabilityResponse = {
  eligible: boolean;
  selected: WelcomeBonusSelectionData | null;
  options: {
    sportsbook: WelcomeBonusOptionData | null;
    casino: WelcomeBonusOptionData | null;
    noBonus: true;
  };
};

export type WelcomeBonusSelectionPayload = {
  option: WelcomeBonusOption;
};

export type FirstDepositBonusResponse = {
  id: string | null;
  bonusProgramType: BonusProgramType;
  campaignName: string;
  description: string | null;
  campaignProduct: CampaignProduct;
  sbWagering: number | null;
  casinoWagering: number | null;
  requiredSbWagering: number | null;
  requiredCasinoWagering: number | null;
  expiryDate: string;
  hasMadeFirstDeposit: boolean;
  minDepositAmount: number;
  bonusPayoutAmount: number | null;
  rewardType: string | null;
  status: BonusStatus | null;
};
